type LegacyCopyNamespace = 'volcanes' | 'shopify';

interface LegacyCopy {
  readonly labelKey: string | null;
  readonly errorKeys: Readonly<Record<string, string>>;
  readonly fallbackErrorKey: string;
}

const LEGACY_COPY: Readonly<Record<LegacyCopyNamespace, LegacyCopy>> = {
  volcanes: {
    labelKey: null,
    errorKeys: {
      'empty': 'emptyCardSecurityCode',
      'invalid-pattern': 'invalidSecurityCode',
    },
    fallbackErrorKey: 'invalidCvv',
  },
  shopify: {
    labelKey: 'inputCardSecurityCode',
    errorKeys: {
      'empty': 'fillCardSecurityCode',
      'invalid-pattern': 'invalidSecurityCode',
    },
    fallbackErrorKey: 'invalidCvv',
  },
};

export { LEGACY_COPY };
export type { LegacyCopyNamespace };
